import { PARTNER_TYPES } from 'Constants/partnerTypes';

export const ADDED_CONSENT = 'ADDED_CONSENT';
export const UPDATED_CONSENT = 'UPDATE_CONSENT';
export const LOADED_CONSENTS = 'LOADED_CONSENTS';
export const LOADED_PENDING_CONSENTS = 'LOADED_PENDING_CONSENT';
export const REMOVED_CONSENT = 'REMOVED_CONSENT';
export const REMOVED_PENDING_CONSENT = 'REMOVED_PENDING_CONSENT';

export interface Consent {
  clientId: string;
  scopes: string[];
  created?: number;
  needsMigration?: boolean;
  scopeDetails?: ScopeDetails;
}

export interface PendingConsent {
  clientId: string;
  created?: number;
}

interface BasePartner {
  id: string;
  logo?: string;
  name: string;
  transGroupKey?: string;
  hideDisclaimer: boolean;
}

export interface PartnerApi extends BasePartner {
  type: PARTNER_TYPES.API; // discriminate

  connectKey?: string;
  connectUrl: string;
  display?: boolean;
  translations: TranslationsData;
  rn?: boolean;
}

export interface PartnerCommercialApi extends BasePartner {
  type: PARTNER_TYPES.COMMERCIAL_API; // discriminate

  translations: TranslationsData;
  scopes: string[];
  scopeDetails: ScopeDetails;
}

export interface PartnerFhir extends BasePartner {
  type: PARTNER_TYPES.FHIR; // discriminate

  connectKey?: string;
  connectUrl: string;
  display?: boolean;
  translations: TranslationsData;
  subType: string;
}

export interface PartnerInbound extends BasePartner {
  type: PARTNER_TYPES.INBOUND; // discriminator
  display?: boolean;
  translations: TranslationsData;
  rn?: boolean;
}

export interface PartnerInsulet extends BasePartner {
  type: PARTNER_TYPES.INSULET; // discriminator
  display?: boolean;
}

export interface PartnerRedox extends BasePartner {
  type: PARTNER_TYPES.REDOX; // discriminate
}

export type Partner =
  | PartnerApi
  | PartnerCommercialApi
  | PartnerFhir
  | PartnerInbound
  | PartnerInsulet
  | PartnerRedox;

export interface PartnerMap {
  [id: string]: Partner;
}

export interface PartnerState {
  connected: Consent[];
  pendingConnections: PendingConsent[];
  partners: PartnerMap;
  consentsLoaded: boolean;
  pendingConsentsLoaded: boolean;
}

interface LoadedConsentsAction {
  type: typeof LOADED_CONSENTS;
  consents: Consent[];
}

interface RemovedConsentAction {
  type: typeof REMOVED_CONSENT;
  partnerId: string;
}

interface AddedConsentAction {
  type: typeof ADDED_CONSENT;
  consent: Consent;
}

interface UpdatedConsentAction {
  type: typeof UPDATED_CONSENT;
  consent: Consent;
}

interface LoadedPendingConsentAction {
  type: typeof LOADED_PENDING_CONSENTS;
  pendingConsents: PendingConsent[];
}

interface RemovedPendingConsentAction {
  type: typeof REMOVED_PENDING_CONSENT;
  partnerId: string;
}

export type PartnerActions =
  | LoadedConsentsAction
  | LoadedPendingConsentAction
  | RemovedConsentAction
  | RemovedPendingConsentAction
  | AddedConsentAction
  | UpdatedConsentAction;

export interface TranslationsData {
  fallback: {
    default: string[];
    [code: string]: string[];
  };
  languages: {
    default: TranslationKeys;
    [code: string]: TranslationKeys;
  };
}

interface TranslationKeys {
  [key: string]: string;
}
